import { axiosBase, errorHandler } from "./axios";


const getEventFinancial = (eventId: string) =>
  axiosBase
    .get(`/api/v1/financial/events/${eventId}`)
    .then((r) => r.data)
    .catch(errorHandler);


const getEventFinance = (eventId: string) =>
  axiosBase
    .get(`/api/v1/payments/finance/${eventId}`)
    .then((r) => r.data)
    .catch(errorHandler);


const createPayment = (formData: FormData) =>
  axiosBase
    .post("/api/v1/payments/payment", formData)
    .then((r) => r.data)
    .catch(errorHandler);

const updatePayment = (paymentId: string, formData: FormData) =>
  axiosBase
    .put(`/api/v1/payments/payment/${paymentId}`, formData)
    .then((r) => r.data)
    .catch(errorHandler);

const deletePayment = (paymentId: string) =>
  axiosBase
    .delete(`/api/v1/payments/payment/${paymentId}`)
    .then((r) => r.data)
    .catch(errorHandler);

const createFinancialAlert = (data: any) =>
  axiosBase
    .post("/api/v1/financial/alerts", data)
    .then((r) => r.data)
    .catch(errorHandler);

const updateFinancialAlert = (alertId: string, data: any) =>
  axiosBase
    .put(`/api/v1/financial/alerts/${alertId}`, data)
    .then((r) => r.data)
    .catch(errorHandler);

const deleteFinancialAlert = (alertId: string) =>
  axiosBase
    .delete(`/api/v1/financial/alerts/${alertId}`)
    .then((r) => r.data)
    .catch(errorHandler);

const createExpenseContact = (data: any) =>
  axiosBase
    .post("/api/v1/financial/expense-contacts", data)
    .then((r) => r.data)
    .catch(errorHandler);

const updateExpenseContact = (contactId: string, data: any) =>
  axiosBase
    .put(`/api/v1/financial/expense-contacts/${contactId}`, data)
    .then((r) => r.data)
    .catch(errorHandler);

const deleteExpenseContact = (contactId: string) =>
  axiosBase
    .delete(`/api/v1/financial/expense-contacts/${contactId}`)
    .then((r) => r.data)
    .catch(errorHandler);


const createExpense = (data: any) =>
  axiosBase
    .post("/api/v1/financial/expenses", data)
    .then((r) => r.data)
    .catch(errorHandler);

const updateExpense = (expenseId: string, data: any) =>
  axiosBase
    .put(`/api/v1/financial/expenses/${expenseId}`, data)
    .then((r) => r.data)
    .catch(errorHandler);

const deleteExpense = (expenseId: string) =>
  axiosBase
    .delete(`/api/v1/financial/expenses/${expenseId}`)
    .then((r) => r.data)
    .catch(errorHandler);


const createPayout = (data: any) =>
  axiosBase
    .post("/api/v1/financial/payouts", data)
    .then((r) => r.data)
    .catch(errorHandler);

const updatePayout = (payoutId: string, data: any) =>
  axiosBase
    .put(`/api/v1/financial/payouts/${payoutId}`, data)
    .then((r) => r.data)
    .catch(errorHandler);

const deletePayout = (payoutId: string) =>
  axiosBase
    .delete(`/api/v1/financial/payouts/${payoutId}`)
    .then((r) => r.data)
    .catch(errorHandler);


const financialService = {
  getEventFinancial,
  getEventFinance,
  createPayment,
  updatePayment,
  deletePayment,
  createFinancialAlert,
  updateFinancialAlert,
  deleteFinancialAlert,
  createExpense,
  updateExpense,
  deleteExpense,
  createPayout,
  updatePayout,
  deletePayout,
  createExpenseContact,
  updateExpenseContact,
  deleteExpenseContact,
};

export default financialService;
